<template>
  <b-container fluid>
    <FormulateForm
      name="createContact"
      @submit="submitHandler"
      #default="{ isLoading }"
      v-model="formValues"
      data-cy="create-contact-form"
    >
      <b-row>
        <b-col lg="6" offset-lg="3">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">Contact info</h4>
            </template>
            <template v-slot:body>
              <b-form-row>
                <b-col>
                  <b-form-group label="First name" label-for="firstName">
                    <FormulateInput
                      id="firstName"
                      name="firstName"
                      type="text"
                      input-class="form-control"
                      data-cy="first-name-input"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Last name" label-for="lastName">
                    <FormulateInput
                      id="lastName"
                      name="lastName"
                      type="text"
                      input-class="form-control"
                      data-cy="last-name-input"
                    />
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form>
                <b-form-group label="Email " label-for="email">
                  <FormulateInput
                    id="email"
                    name="email"
                    type="email"
                    validation="required"
                    input-class="form-control"
                    data-cy="email-input"
                  />
                </b-form-group>
                <b-form-group label="Phone" label-for="phone">
                  <FormulateInput
                    id="phone"
                    name="phone"
                    type="tel"
                    input-class="form-control"
                    data-cy="phone-input"
                  />
                </b-form-group>
                <b-form-group label="Title " label-for="title">
                  <FormulateInput
                    id="title"
                    name="title"
                    type="text"
                    input-class="form-control"
                    data-cy="title-input"
                  />
                </b-form-group>
              </b-form>
              <b-form-group label="Company" label-for="companyId">
                <FormulateInput
                  id="companyId"
                  name="companyId"
                  type="select"
                  placeholder="Choose company"
                  data-cy="company-select"
                  :options="companiesOptions"
                  @change="handleCompanyChange"
                />
              </b-form-group>
              <b-form-group label="Consent" label-for="consent">
                <FormulateInput
                  id="consent"
                  name="consent"
                  type="select"
                  validation="required"
                  placeholder="Choose consent"
                  data-cy="consent-select"
                  :options="consentOptions"
                />
              </b-form-group>
            </template>
          </iq-card>
        </b-col>
        <!-- <b-col lg="6" offset-lg="3">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">Custom data</h4>
            </template>
            <template v-slot:body>
              <b-form>
                <b-form-group
                  label="Pass custom data here in JSON format"
                  label-for="customData"
                >
                  <FormulateInput type="textarea" name="customData" />
                </b-form-group>
              </b-form>
            </template>
          </iq-card>
        </b-col> -->
        <b-col lg="2" offset-lg="3">
          <router-link to="/contacts">
            <b-button block variant="outline-primary" class="mb-3 mr-1"
              >Back to contacts</b-button
            >
          </router-link>
        </b-col>
        <b-col lg="4">
          <b-button
            block
            type="submit"
            variant="primary"
            class="mb-3 mr-1"
            data-cy="submit-button"
            :disabled="isLoading || !isValid"
            :label="isLoading ? 'Loading...' : 'Submit this form'"
            >Save contact</b-button
          >
        </b-col>
      </b-row>
    </FormulateForm>
    <b-modal
      id="create-company"
      title="Create new company"
      hide-footer
      v-model="showCreateCompany"
    >
      <b-row>
        <b-col>
          <CompanyFormCreate v-on:company-created="handleCompanyCreated" />
        </b-col>
      </b-row>
    </b-modal>
  </b-container>
</template>

<script>
import { core } from "../../config/pluginInit";
import CompanyFormCreate from "./Components/CompanyFormCreate.vue";

import gql from "graphql-tag";
const CREATE_CONTACT = gql`
  mutation createContact(
    $firstName: String
    $lastName: String
    $email: String!
    $phone: String
    $companyId: uuid
    $consent: consent_enum_enum!
    $title: String
  ) # $customData: jsonb
  {
    insert_contacts_one(
      object: {
        first_name: $firstName
        last_name: $lastName
        email: $email
        phone: $phone
        company_id: $companyId
        consent: $consent
        title: $title
        # custom_data: $customData
      }
    ) {
      id
      first_name
      last_name
      email
      phone
      company_id
      title
      # custom_data
    }
  }
`;
const SET_COMPANY_PRIMARY_CONTACT_ID = gql`
  mutation setCompanyPrimaryContactId(
    $companyId: uuid!,
    $contactId: uuid!
  ) {
    update_companies_by_pk(
      pk_columns: {
        id: $companyId
      },
      _set: {
        primary_contact_id: $contactId
      }
    ){
      id
      primary_contact_id
    }
  }
`;
const LIST_COMPANIES = gql`
  query listCompanies {
    companies {
      id
      name
    }
  }
`;
const LIST_CONSENT_ENUM = gql`
  query {
    consent_enum {
      value
      description
    }
  }
`

export default {
  name: "ContactsCreate",
  components: {
    CompanyFormCreate
  },
  data() {
    return {
      formValues: {},
      companies: [],
      showCreateCompany: false,
      newCompanyCreated: false,
    };
  },
  apollo: {
    companies: {
      query: LIST_COMPANIES
    },
    consent_enum: {
      query: LIST_CONSENT_ENUM
    }
  },
  computed: {
    companiesOptions() {
      return [
        { value: "new", label: "* create new company *" },
        ...this.companies.map(o => ({
          value: o.id,
          label: o.name
        })),
      ];
    },
    consentOptions(){
      return this.consent_enum?.map(i => ({
        value: i.value,
        label: i.description
      }))
    },
    isValid(){
      if (this.formValues.consent === 'NO_CONSENT') {
        return false;
      }
      return true;
    }
  },
  methods: {
    async submitHandler() {
      try {
        const createContactResponse = await this.$apollo.mutate({
          mutation: CREATE_CONTACT,
          variables: {
            firstName: this.formValues.firstName,
            lastName: this.formValues.lastName,
            email: this.formValues.email,
            phone: this.formValues.phone,
            companyId: this.formValues.companyId,
            consent: this.formValues.consent,
            title: this.formValues.title,
            // customData: this.formValues.customData
            //   ? JSON.parse(this.formValues.customData)
            //   : {}
          }
        });
        this.$toast.success(`Contact saved`);
        this.$formulate.reset("createContact");

        if (this.newCompanyCreated === true) {
          await this.$apollo.mutate({
            mutation: SET_COMPANY_PRIMARY_CONTACT_ID,
            variables: {
              companyId: createContactResponse.data.insert_contacts_one.company_id,
              contactId: createContactResponse.data.insert_contacts_one.id,
            }
          })
        }
      } catch (error) {
        this.$toast.error(`Failed to save contact: ${error.message}`);
      }
    },
    handleCompanyChange(e) {
      if (e.target.value === "new") {
        this.showCreateCompany = true;
        this.formValues.companyId = "";
      }
    },
    async handleCompanyCreated(c) {
      await this.$apollo.queries.companies.refetch();
      this.showCreateCompany = false;
      this.formValues.companyId = c.id;
      this.newCompanyCreated = true;
      // console.log("newly created company is:", c);
    }
  },
  mounted() {
    core.index();
  }
};
</script>
